module.exports = __webpack_public_path__ + "img/linkedin.e6e5aa81.svg";